<template>
  <bp-tooltip-popper
    :disabled="disabled"
    :options="popperOptions"
    :trigger="text ? 'hover' : ''"
  >
    <slot slot="reference"></slot>

    <div class="bp-tooltip-el" slot="default">
      <slot name="content">
        <span class="functional-1">
          {{ text }}
        </span>
        <slot name="button" />
      </slot>
    </div>
  </bp-tooltip-popper>
</template>
<script>
import Popper from "vue-popperjs";
import "vue-popperjs/dist/vue-popper.css";
export default {
  components: { "bp-tooltip-popper": Popper },
  props: {
    text: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    popperOptions() {
      return {
        placement: "right",
        modifiers: {
          offset: {
            offset: "0,4px"
          }
        }
      };
    }
  }
};
</script>
<style lang="scss" scoped>
.bp-tooltip-el {
  color: #fff;
  max-width: 264px;
  z-index: 99999999;
  padding: 8px 12px;
  width: max-content;
  border-radius: 4px;
  height: fit-content;

  background: var(--Semantic-Neutral-900, #2a2a2a);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.12);
}
</style>
